import { useEffect, useState } from "react";
import Dashboard from "../../Components/Dashboard";
import Document from "../../Components/Document";

import Loader from "../../loader";

const DocumentPage = () => {
  return (
    <>
      <Document />
    </>
  );
};
export default DocumentPage;
